<!-- eslint-disable indent -->
<template>
  <div class="main" v-cloak>
    <div class="el-breadcrumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>全部品牌</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="brand clear">
      <div class="brand-li" v-for="(item, index) in listData" @click="brandClick(item)">
        <div class="logo">
          <img :src="item.brand_img" alt="">
        </div>
        <p>{{ item.brand_name }}</p>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        listData: []
      }
    },
    mounted() {
      this.getbrandLists()
    },
    methods: {
      brandClick(item) {
        this.$router.push({
          path: "/pages/shop/prolist",
          query: {
            brand_id: item.id,
            isPingPai: true,
            name: item.brand_name,
          }
        })
      },
      getbrandLists() {
        this.$http.post('?s=/apiPc.Product/brandList').then(response => {
            this.listData = response.data;
          })
          .catch(error => {});
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    padding: 0 123px;
    background: #f5f5f5;
  }

  .main .el-breadcrumbs {
    padding-top: 30px;
  }


  .clear::after {
    content: "";
    display: block;
    clear: both;
  }

  .main .brand {
    display: flex;
    flex-wrap: wrap;
  }

  .main .brand .brand-li {
    width: 18%;
    margin: 20px 1%;
    background: #FFFFFF;
    cursor: pointer;
  }

  .main .brand .brand-li .logo {
    width: 100%;
    height: 300px;
  }

  .main .brand .brand-li p {
    font-size: 16px;
    line-height: 34px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/shop/brandlist.vue